<div class="action-btn-container">

    <div class="top-section">
        <span class="title font-poppins">Tools</span>

        <div class="action-container">
            <div class="action-icon-container" [ngClass]="{active: !isColorSectionOpen}" (click)="toggleSection()">
                <mat-icon svgIcon="shapes"></mat-icon>
            </div>

            <div class="action-icon-container" [ngClass]="{active: isColorSectionOpen}" (click)="toggleSection()" [tourAnchor]="DesignerTourSteps.actions.anchorId!">
                <mat-icon svgIcon="color"></mat-icon>
            </div>
        </div>
    </div>

    <div class="bottom-section">
        @if (isColorSectionOpen) {
            <div class="transform-section">
                <p class="transform-title font-poppins">Transform</p>

                <div class="transform-action-container" [tourAnchor]="DesignerTourSteps.flips.anchorId!">
                    @for (action of actionsBtns;let i = $index; track i) {
                        <span class="icon-container" [matTooltip]="action.action" [ngClass]="{ disabled: !meshes.length }" (click)="!isStepTourActive && actions(i, action)">
                            <mat-icon>{{ action.label }}</mat-icon>
                        </span>
                    }
                </div>
            </div>

            <div class="color-section">
                <p class="color-title font-poppins">Select Color</p>

                <div [tourAnchor]="DesignerTourSteps.colourPicker.anchorId!">
                    <colour-picker></colour-picker>
                </div>
            </div>

        } @else {
            <div class="shape-section">
                <p class="shape-title font-poppins">Block shapes</p>

                <div [tourAnchor]="DesignerTourSteps.shapeSelector.anchorId!">
                    <shape-selector></shape-selector>
                </div>
            </div>

            <button mat-stroked-button class="guide-btn" [tourAnchor]="DesignerTourSteps.guide.anchorId!" (click)="!isStepTourActive && triggerOnBoardingDialog()">
                <mat-icon svgIcon="tip" class="guide-icon"></mat-icon>
                GUIDE
            </button>
        }
    </div>

</div>
